import { type FormikValues } from "formik";
import { apiRequest } from "shared/api/apiRequest";
import { patchSocietyProfileReviewAssignmentRecuseContract } from "shared/api/contracts/society/societyId/profiles/profileId/review/assignments/reviewAssignmentId/recuse";
import PillarForm from "shared/components/pillar-form/PillarForm";
import PillarModalBody from "shared/components/pillar-modal/NewPillarModalBody";
import { ModalMinWidth } from "shared/components/pillar-modal/PillarModalBody";
import { useCustomRouter } from "shared/context/CustomRouterContext";
import { useCustomSession } from "shared/context/CustomSessionContext";
import * as Yup from "yup";
import { queryClient } from "hub/src/api/client/query-client";
import { useHubReviewsVotingPageContext } from "hub/src/context/reviews/HubReviewsVotingPageContext";
import { getSocietyId } from "hub/src/utils/getSocietyId";

export const HubReviewsRecusalModal = () => {
  const session = useCustomSession();
  const router = useCustomRouter();
  const {
    reviewInstanceAssignment,
    reviewSession,
    recusalModalControl,
    nextInstanceId,
  } = useHubReviewsVotingPageContext();

  const isLastReviewAssignment = !nextInstanceId;

  const handleRecuse = async (formValues: FormikValues) => {
    apiRequest({
      contract: patchSocietyProfileReviewAssignmentRecuseContract,
      inputs: {
        params: {
          societyId: getSocietyId(),
          profileId: session.profileId!,
          reviewAssignmentId: Number(
            reviewInstanceAssignment.reviewInstanceAssignmentId,
          ),
        },
        body: {
          recusalReason: formValues.reasonForRecuse,
        },
      },
    });

    await queryClient.invalidateQueries({
      queryKey: ["reviewSessions"],
    });
    if (!isLastReviewAssignment) {
      router.push(`/reviews/${reviewSession.id}/instance/${nextInstanceId}`);
    } else {
      router.push("/reviews");
    }
    recusalModalControl.setIsOpen(false);
  };
  return (
    <PillarModalBody
      minW={ModalMinWidth.Sm_500}
      control={recusalModalControl}
      title="Recuse Review"
    >
      <div className="py-2">
        <PillarForm
          handleSubmit={handleRecuse}
          yupValidation={Yup.object().shape({
            reasonForRecuse: Yup.string().required(
              "Recusal reason is required",
            ),
          })}
        >
          <PillarForm.TextAreaInput
            rows={5}
            name="reasonForRecuse"
            label="Reason for recuse"
            placeholder="Enter a reason"
          />
          <div className="pt-2 flex justify-around">
            <PillarForm.Button
              onClick={() => recusalModalControl.setIsOpen(false)}
              className="button-regular-neutral-filled"
              title="Close"
              label="Close"
            />
            <PillarForm.LoadingSubmitButton
              title="Recuse"
              label="Recuse"
              data-testid="completeRecusalButton"
            />
          </div>
        </PillarForm>
      </div>
    </PillarModalBody>
  );
};
